<template>
    <div  >
        <div v-if="club!=null">
         
           
            <div class="info2Club">
                <div>
                    
                    <modal-visible
                        :open="openModalPublic"
                        @close="openModalPublic=false"
                        :club="club"
                        />
                    <s-modal
                        :open="qrcode"
                        :close="true"
                        @close="qrcode=false"
                    >
                        <div style="text-align:center">
                         <vue-qrcode :value="linkClub" :color="{ dark: '#000000', light:'#ffffff' }" />
                         <br/>
                         {{linkClub}}
                        </div>
                    </s-modal>
                    <span class="g_desktopOn">
                        <s-button @onclick="qrcode=true" icon="qrcode" label="QRCode du club" theme="is-primary"/>
                    </span>
                    
                    &nbsp;
                    <s-you-tube id="video_club" :club="club" />
                    <div class="g_mobileOn">
                    <div  style="display:inline-block;margin-top: 10px">
                        <s-button @onclick="qrcode=true" icon="qrcode" label="QRCode du club" mode="V" theme="is-primary"/>
                    </div>
                    </div>
                    <div style=";margin-top: 10px;margin-bottom: 10px"  class="g_desktopOn"> 
                            <div style="display:inline-block;width: 150px;margin-right: 10px">
                            <s-button icon="globe-americas" 
                                theme="is-primary is-medium" 
                                label="Rendre visible" 
                                v-if="$getRole()=='owner'"
                                mode="V"
                                @onclick="setOpenModalPublic()" 
                            />
                            </div>
                            <div style="display:inline-block;width: 150px;margin-right: 10px">
                            <s-button 
                                theme="is-warning is-medium" 
                                label="Modifier" 
                                icon="edit" 
                                @onclick="editClubModal=true"
                                v-if="$getRole()=='owner'"
                                :role="$getRole()"
                                mode="V"
                            />
                            </div>
                    </div>
                        <div class="g_desktopOn">
                            <div style="display:inline-block;width: 150px;margin-right: 10px" > 
                            <s-button  theme="is-medium is-primary" label="Organigramme" icon="sitemap" @onclick="openModalOrganigramme()" mode="V"/>
                            </div>
                            <div style="display:inline-block;width: 150px;margin-right: 10px" > 

                                <s-button icon="th" 
                                    theme="is-dark is-medium" 
                                    label="Configurer les terrains du club" 
                                    v-if="$getRole()=='owner'"
                                    mode="V"
                                    @onclick="openConfigTerrain=true" 
                                />
                            </div>
                        </div>
                        <div>
                       
                    </div>
                </div>
                
            </div>
            <div class="g_menuMobile" v-show="!editClubModal">
                <table class="g_menuFooterMin">
                    <tr>
                        <td colspan="5" class="g_headerFooter">
                            <span v-show="clubIsSubscription"> Abonnement  activé<br/> </span>
                            <span v-show="!clubIsSubscription"> Aucun abonnement <br/>
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                           
                            <s-button theme="is-light" 
                                label="Mes clubs" 
                                icon="list" 
                                @onclick="goMesClubs()" 
                                mode="V"
                                v-if="!$isAnonyme()" 
                            />
                        </td>
                        <td>
                            <s-button theme="is-light" 
                                      label="Concours" 
                                      icon="trophy" 
                                       id="concours"
                                      @onclick="goConcours"
                                      mode="V"
                            />
                        </td>
                        <td>
                            <s-button theme="is-light" 
                                      label="Saisons" 
                                      icon="film" 
                                      mode="V"
                                      id="saisons"
                                      @onclick="goSaison"
                            />
                        </td>
                        <td>
                            <s-button 
                                      theme="is-light" 
                                      label="Membres" 
                                      icon="users" 
                                      @onclick="goMembres"
                                      id="membres"
                                      mode="V"
                                      v-if="$getRole()=='admin' || $getRole()=='owner'"
                            />                            
                        </td>
                        <td>
                             <s-button icon="th" 
                                theme="is-dark" 
                                label="Configurer les terrains" 
                                v-if="$getRole()=='owner'"
                                mode="V"
                                @onclick="openConfigTerrain=true" 
                            />
                            <s-button 
                                theme="is-warning" icon="signature" 
                                label="Adhérer" 
                                @onclick="modalDemandeAdhesion=true" mode="V" 
                                v-if="demandeAdhesion==0 && !$isAnonyme() && club.adhesion"
                                v-show="$getRole()=='visiteur'"  />
                             <s-button 
                                theme="is-success" icon="signature" 
                                label="en cours" 
                                :disabled="true"
                                 mode="V" 
                                v-if="demandeAdhesion==1 && !$isAnonyme() && club.adhesion"
                                v-show="$getRole()=='visiteur'"  />

                            <s-button 
                                v-if="$isAnonyme() && demandeAdhesion==0  && club.adhesion" 
                                icon="signature" 
                                @onclick="modalLogin=true"  
                                label="Adhérer" 
                                theme="is-warning" mode="V"/>
             

                        </td>
                    </tr>
                </table>
            </div>
            <div style="padding: 10px;height: 150px;display:inline-block;" v-if="pathFile!=null">
                <img-file 
                    ref="IMGLOGOCLUB" 
                    :pathFile="pathFile" 
                    width="120px" 
                    height="120px" 
                    :role="$getRole()"
                    @onclick="upload()"
                    @finish="uploadInProgress = false" 
                    :upload="true"
                    :exists="club.logo ? true : false"
                />
                <img-upload :pathFile="pathFile" @refresh="setRefreshFile" @start="uploadInProgress = true"/>

                <waiting :open="uploadInProgress"/>
            </div>
            <div class="infoClub" style="padding-top: 10px;" v-if="club">
                <div class="titlename" >
                   {{club.name}}
                </div>
                <div >
                    {{club.president}}
                </div>
                <div>
                    <div v-show="club.tel!=''">
                       {{club.tel}}
                        <a :href="'tel:+'+club.tel">
                            <s-button theme="is-primary is-small" label="" icon="phone" 
                                @onclick=""
                                :role="$getRole()"
                            />
                        </a>
                    </div>
                </div>
                <div  >
                    <div v-if="club.type==0">
                        <span class="icon"  >
                            <i class="fas fa-child"></i>
                        </span>&nbsp;Club Familiale
                     </div>    
                    <div v-if="club.type==1">
                        <span class="icon">
                        <i class="fas fa-umbrella-beach"></i>
                    </span>&nbsp;Club de vacance
                    </div>    
                    <div v-if="club.type==2">
                    <span class="icon" >
                        <i class="fas fa-basketball-ball"></i>
                    </span>&nbsp;Club amateur
                    </div>
                    <div v-if="club.type==3">
                        <span class="icon" >
                        <i class="fas fa-user-tie"></i>
                    </span>&nbsp;Club Pro
                    </div>
                </div>
                
                 
                 
            </div>

        <div class="cartouche">
            
            
            <div>
                   
                    <span v-if="club.nbJoueurs">{{club.nbJoueurs}} </span>
                    <span v-else>0 </span>
                        Membres
                </div>
                
                <div v-if="$getRole()=='visiteur'">
                    <s-l id="viewClub_visiteur">Vous êtes visiteur, vous ne faites pas parti de ce club</s-l>
                    <br/>
                    <div  v-if="$isAnonyme() && club.adhesion" > 
                        <div v-on:click="modalLogin=true" class="connecter">
                        Si vous voulez adhérer à ce club, vous devez créer votre compte
                       <br/>
                       
                        </div><br/>
                        <s-modal 
                            title="Se connecter"
                            :open="modalLogin"
                            :close="true"
                            @close="modalLogin=false"
                        >
                            <form-login @close="closeLogin()" notModal="false"/>
                        </s-modal>
                    </div>
                </div>
                 <div v-for="user in club.users" v-if="user.role=='owner' && $getRole()!='visiteur'" >
                    <span v-if=" user.id!=$store.getters.getUser.id">invité par {{user.pseudo}}</span>
                    <span v-if="user.id==$store.getters.getUser.id" ><b> Vous en êtes le GESTIONNAIRE</b></span>
                    <div v-if="$getRole()=='admin'" > <b>Vous êtes ORGANISATEUR</b><br/>
                        <i style="font-size:13px" v-if="clubIsSubscription">Le club possède un abonnement, vous pouvez créer des concours</i>
                        <i style="font-size:13px" v-if="!clubIsSubscription">Le club ne possède pas d'abonnement, vous ne pouvez pas créer de concours mais vous pouvez organiser les concours crées par le gestionnaire</i>
                    </div>
                    <div v-if="$getRole()=='player'">
                        <s-l id="viewClub_player">Vous êtes un joueur, vous faites parti de ce club</s-l>
                     </div>
                     <div v-if="$getRole()=='invite'">
                        <s-l id="viewClub_invite">Vous n'êtes pas membre de ce club, mais vous pouvez participer à un des concours</s-l>
                     </div>
                </div>
               
                <div v-if="$getRole()=='admin' || $getRole()=='owner'" :class="demandeNbAdhesion!=0 ? 'demandeNbAdhesion' : ''" v-on:click="goDemandeAdhesion()">
                    <span class="icon is-danger" v-if="demandeNbAdhesion!=0">
                        <i class="fas fa-exclamation-triangle"></i>
                    </span>
                    Vous avez {{demandeNbAdhesion}} demande(s) d'adhésion 
                </div>
                <div v-if="club.urlsite!='' && club.urlsite!=null">
                    Site du club : <a :href="club.urlsite">{{club.urlsite}}</a>
                </div>
                <div class="descriptionClub">{{club.description}}</div>
            
        </div>
        <div class="buttons g_desktopOn" >
            <div v-if="!$isAnonyme()" 
                v-show="$getRole()=='visiteur'">
            
            <s-button 
                theme="is-warning is-large" icon="signature" 
                label="Demander à être membre du club" 
                @onclick="modalDemandeAdhesion=true" mode="V" 
                v-if="demandeAdhesion==0 && club.adhesion"  />
            <s-button 
                theme="is-success is-large" icon="signature" 
                label="Demande en cours pour être membre du club" 
                @onclick="modalDemandeAdhesion=true" mode="V" 
                :disabled="true"
                v-if="demandeAdhesion==1" />
            
            <s-button 
                theme="is-danger is-large" icon="ban" 
                label="Demande rejetée pour être membre du club" 
                @onclick="modalDemandeAdhesion=true" mode="V" 
                :disabled="true"
                v-if="demandeAdhesion==-1" />
          
            </div>
            <div v-if="!$isAnonyme() && !club.demo" 
                v-show="$getRole()=='owner'">
            <s-button 
                :theme="clubIsSubscription ? 'is-success is-large' : 'is-danger is-large'" icon="credit-card" 
                :label="clubIsSubscription ? 'Voir l\'abonnement' : 'Abonnez votre club'" 
                @onclick="subscribe" mode="V"  />
            </div>
            <div>
            <s-button theme="is-primary is-large" icon="trophy" label="Voir tous les concours du club" @onclick="goConcours" mode="V"/>
            </div>
            <div>
            <s-button theme="is-primary is-large" icon="film" label="Voir toutes les saisons du club" @onclick="goSaison" mode="V"/>
            </div>
            <div v-if="$getRole()=='owner' || $getRole()=='admin'">
                <s-button theme="is-primary is-large" icon="users" label="Voir les membres" @onclick="goMembres" mode="V"  v-if="!$isAnonyme()"/>
            </div>
            <div v-if="$isAnonyme() && club.adhesion" >
              <s-button icon="signature"  @onclick="modalLogin=true"  label="Adhérer" theme="is-success is-large" mode="V"/>
            </div>      
        </div> 
        <div v-show="$getRole()=='owner' || $getRole()=='admin'" class="abonnement">
            <div v-show="clubIsSubscription && !club.demo" style="color:green" >
                <s-l id="viewClub_subscription_active"> Votre abonnement est activé<br/></s-l> </div>
            <span v-show="!clubIsSubscription && !club.demo" class="g_desktopOn"> 
                <s-l id="viewClub_subscription_not" v-show="$getRole()=='owner'">Ce club ne contient pas d'abonnement <br/>Pour 10€ par mois ou 100€ à l'année, vous pouvez créer autant de concours que vous le souhaitez...<br/></s-l>
            </span>
            <span v-show="cancelSubscription!=null && !club.demo" class="swarning" v-if="$getRole()=='owner'">
                <s-l id="viewClub_cancelsubscription" :v="cancelSubscription">Vous avez annulé votre abonnement. il prendra fin le %v</s-l>
            </span>
            <span v-if="club.demo && dayExpired>0">
                <s-l id="viewClub_explainDemoSup" :v="dayExpired()">Club Démo : Il pourra être supprimé automatique dans %v jours.</s-l>
            </span>
            <span v-if="club.demo && dayExpired<0">
                <s-l id="viewClub_explainDemoSup" :v="dayExpired()">Ce club est un club démo. Il pourra être supprimé à tout moment.</s-l>
            </span>
        </div>
        <div class="g_mobileOn">
            <table style="width:100%">
            <tr>
                <td style="width:25%">
                    <s-button  theme="is-medium is-primary" label="Organigramme" icon="sitemap" @onclick="openModalOrganigramme()" mode="V"/>
                </td>
                <td style="width:25%">
                                    <s-button icon="globe-americas" 
                                        theme="is-primary is-medium" 
                                        label="Rendre visible" 
                                        v-if="$getRole()=='owner'"
                                        mode="V"
                                        @onclick="setOpenModalPublic()" 
                                    />
                </td>
               
               
                <td  style="width:25%">
                     <s-button theme="is-info is-medium" label="Abonnement" icon="credit-card" 
                        @onclick="subscribe"
                        mode="V"
                        v-if="$getRole()=='owner' && !club.demo"
                    />
                </td>
                 <td  style="width:25%">
                <s-button 
                    theme="is-warning is-medium" 
                    label="Modifier" 
                    icon="edit" 
                    @onclick="editClubModal=true"
                    v-if="$getRole()=='owner'"
                    :role="$getRole()"
                    mode="V"
                />
                </td>
            </tr>
            </table>
        </div>
        <div v-if="club!=null">
            <edit-club 
                :club="club" 
                :role="$getRole()" 
                :open="editClubModal" 
                @close="closeEdit" />
        </div>
        <s-confirm
            title="Supprimer votre club"
            :open="confirmDeleteClub"
            @yes="deleteClub()"
            @no="confirmDeleteClub=false"
                :role="$getRole()"
        >
            <div class="notification is-danger">
                <s-l id="club_delete">Vous êtes sur le point de supprimer votre club...<br/>Tous les tournois et les membres de ce club seront supprimés<br/>Cette action est irrévocable<br/><hr/>Etes vous sûr de le supprimer ?</s-l>
            </div>
        </s-confirm>
        
         <s-modal
            title="Choisir son abonnement"
            :open="openAbonnement"
            :close="true"
            @close="openAbonnement=false"
        >
            <list-subscriptions :club="club"/>
        </s-modal>    
        <s-modal
            title=""
            :open="modalDemandeAdhesion"
            @save="demandeMembre"
            :save="joueurAdhesion.nom.length>2"
            @cancel="modalDemandeAdhesion=false"
            :cancel="true"
            @close="modalDemandeAdhesion=false"
            :close="true"
            title="Demande d'adhésion"
        >
                <s-l id="demandeAdhesion" :v="club.name"><p>Vous êtes sur le point d'effectuer une demande d'adhésion pour le club %v</p><p>Il vous faut mettre un nom et un prénom :</p></s-l>
                <div style="margin-bottom: 20px">
                    <div style="width: 100px;display:inline-block">
                        Nom :
                    </div><s-input theme="is-danger" v-model="joueurAdhesion.nom" width="200px"/>
                </div>
                <div>
                    <div style="width: 100px;display:inline-block">
                        Prénom :
                    </div><s-input theme="is-light" v-model="joueurAdhesion.prenom" width="200px"/>
                </div>
        </s-modal>
        <s-modal
            title="Organigramme"
            :open="modalOrganigramme"
            @close="modalOrganigramme=false"
            :close="true"
        >
            <div style="margin='2px'">
            <b>Président : </b><span v-if="club.president==''"><i>non renseigné</i></span>{{club.president}}
            </div>
            <div style="margin='2px'">
            <b>Gestionnaire du club :</b> {{gestionnaire.nom}} {{gestionnaire.prenom}} 
            </div>
            <div style="margin='2px'">
            <b>Organisateurs de concours :</b>
                <div class="organisateurs">
                    <div v-for="organisateur in organisateurs" style="margin: 4px">
                        {{organisateur.nom}}  {{organisateur.prenom}} 
                    </div>
                </div>
            </div>
        </s-modal>
        <config-terrain
            :open="openConfigTerrain"
            :club="club"
            @close="openConfigTerrain=false"
        />
        </div>
        
    </div>

</template>
<style scoped>
   
    .organisateurs {
         overflow-y: auto;
        height: 200px;
        margin: 2px;
        border: thin dashed black;
        padding: 5px;
    }
    
    .demandeNbAdhesion {
        color: red;
        font-weight: bolder;
        text-decoration: underline;
    }
    .demandeNbAdhesion:hover {
        text-decoration: underline;
        cursor: pointer;
    }
    .abonnement {
        margin-top: 20px;
         margin-left: 20px;
        color: red;
        font-size: 14px;
        font-weight: bolder;
        width: 300px;
    }
     @media screen and (max-width: 420px) {
         .cartouche {
                font-size: 18px;
                color: black;
                margin-left: 10px;
                margin-right: 10px;
                padding: 10px;
                margin-bottom: 20px;
            }
            .connecter {
               
                padding: 5px;
            }
            .connecter:hover{
                cursor: pointer;
            }
     }
    @media screen and (min-width: 420px) {
         .cartouche {
                font-size: 18px;
                color: black;
                margin-left: 10px;
                margin-right: 10px;
                padding: 10px;
                margin-bottom: 20px;
            }
            .connecter {
                
                padding: 5px;
               
            }
            .connecter:hover{
                cursor: pointer;
            }
     }
    .buttons {
        width: 95%;
        vertical-align: top;
        margin-top: 70px;
        margin-left: auto;
        margin-right: auto;
        box-shadow: 0px -1px 4px 1px rgb(165, 165, 165);
        padding: 10px;
    }
    .buttons div {
       
        width: 24%;
        vertical-align: top;
    }
    .titlename {
        font-weight: bolder;
        font-size: 24px;
    }
    .buttonCode {
        position: absolute;
        margin-left: auto;
        margin-right: auto;
        bottom: 0px;
        width: 100%;
        text-align: center;
    }
   
    .statePublicActive {
        background-color: rgb(47, 163, 47);
        color: white;
        text-align:center;
        margin-left: auto;
        margin-right: auto;
        margin-top: 20px;
        margin-bottom: 20px;
        width: 80%;
        padding: 5px;
        border-radius: 20px;
        cursor: pointer;
        font-weight: bolder;
    }
    .statePublic {
        background-color: rgb(124, 124, 124);
        color: rgb(202, 202, 202);
        text-align:center;
        margin-left: auto;
        margin-right: auto;
        margin-top: 20px;
        margin-bottom: 20px;
        width: 80%;
        padding: 5px;
        border-radius: 20px;
        cursor: pointer;
        font-weight: bolder;
    }
    
    
    .swarning {
        color: rgb(194, 59, 59);
        font-weight: bolder;
    }
    .info2Club {
        vertical-align: top;
        text-align: right;
        padding: 10px;
        height: 120px;
        font-size: 16px;
        float: right;
        
    }
   
    
    .descriptionClub {
        
    }
    .linkConcours {
        color: black;
        margin-left: 10px;
        font-weight: bold;
    }
    .linkConcours:hover {
        color: rgb(62, 117, 70);
    }
    .ssectionDanger {
        border: thin solid var(--bluebg);
        margin-top: 20px;
        margin-right: 20px;
        height: 180px;
        display: inline-block;
        width: 25%;
        min-width: 360px;
        vertical-align: top;
        position: relative;
    }
    .ssection {
        border: thin solid var(--bluebg);
        margin-top: 10px;
        margin-left: 10px;
        height: 150px;
        display: inline-block;
        width: 90%;
        min-width: 300px;
        vertical-align: top;
        position: relative;
    }
    .ssection:hover {
        cursor: pointer;
         background-color: #d5d9e6;
    }
    
   
    .sheader {
        background-color:  var(--bluebg);
        color: white;
        padding: 5px;
        font-size: 20px;
    }
    .description {
        font-weight: bolder;
        color: black;
        padding: 10px;
    }
    .sbutton {
        position: absolute;
        bottom: 10px;
        right: 10px;
    }
    .infoClub {
        display: inline-block;
        vertical-align: top;
        color: black;
        font-size: 22px;
        margin-left: 10px;
        
    }
    
</style>
<script>
import subscription_fct from "@/firebase/subscription"
import firebase_api from '@/firebase/firebase_api'
import firebase from 'firebase'
import imgUpload from '@/components/imgUpload.vue'
import imgFile from '@/components/imgStore.vue'
import editClub from "@/views/club/edit.vue"
import club_fct from '@/firebase/club'
import listSubscriptions from '@/views/payment/listSubscriptions.vue'
import formLogin from '@/views/auth/Login.vue'
import { firestore } from 'firebase'
import modalVisible from '@/views/club/modalVisible.vue'
import VueQrcode from 'vue-qrcode'
import configTerrain from '@/views/club/configTerrain.vue'
export default {
    components: {
        imgUpload,
        imgFile,
        editClub,
        listSubscriptions,
        formLogin,
        modalVisible,
        VueQrcode,
        configTerrain
    },
    computed: {
        linkClub() {
            var url = window.origin + "/club/" + this.club.id;
            return url;
        },
        demandeNbAdhesion() {
            if (typeof(this.club.demandes)=="undefined")
                return 0;
            else
                return this.club.demandes;
        },
        demandeAdhesion() {
            var demandes =this.$store.getters.getUser.demandes;
            if (typeof(demandes)=="undefined") {
                return 0;
            }
            else {
                if (typeof(demandes[this.club.id])=="undefined") {
                    return 0;
                }
                else {
                    if (demandes[this.club.id].status==null)
                        return 1;
                    else if (demandes[this.club.id].status==false)
                        return -1;
                }
            }
        },
        pathFile() {
            if (this.club!=null) {
            if (this.club.length!=0) {
                var url = '/club/'+this.club.id;
                
                return url;
            }
            else
            return null;
            }
            else
            return null;
        },
        originUrl: {
            get() {
                return window.origin
            }
        },
        cancelSubscription() {
             if (this.club!=null) {
              if (typeof(this.club.subscription) != "undefined") {
                  if (this.club.subscription.cancel_at != null) {
                    var dateCancel =  this.club.subscription.cancel_at.toDate();
                    return dateCancel.toLocaleDateString();
                  }
                  else 
                    return null;
              }
                
              else
                return null;
             }
            else
                return null;
        },
        clubIsSubscription() {
            if (this.club!=null) {
            if (typeof(this.club.subscription) != "undefined")
                    if (this.club.subscription.status == "active") {
                        var date = new Date();
                        var endDate = this.club.subscription.period_end.toDate();
                        var startDate =  this.club.subscription.period_start.toDate();
                        endDate.setDate(endDate.getDate() + 7);
                        
                        if (startDate < date && date < endDate)
                            return true;
                        else
                            return false;
                    }
                    else
                        return false;
                else
                    false;
            }
            else
                return false;
        }
    },
    data() {
        return {
            qrcode: false,
            modalDemandeAdhesion: false,
            uploadInProgress: false,
            uploadPathFile: null,
            editClubModal: false,
            confirmDeleteClub: false,
            openAbonnement: false,
            isReelPlayer: false,
            club: null,
            openModalPublic: false,
            openConfigTerrain: false,
            joueurAdhesion: {
                nom: "",
                prenom: ""
            },
            modalLogin: false,
            videoOn: false,
            modalOrganigramme:false,
            organisateurs : [],
            gestionnaire: {nom: "", email: ""}
        }
    },
    
    async beforeMount() {
        var idClub = this.$route.params.id;
        if (idClub=="demo") {
             this.$router.push({name: "club"}).catch(error=>{});
        }
        else if (this.$store.getters.getUser!=null) {
            await this.$bind("club", firebase_api.api.getDb().collection('club').doc(idClub));
                
            
            var goToHome = false;
            if (this.$getRole()=="visiteur")
                if (typeof(this.club.public)!="undefined")
                    goToHome = !this.club.public;
            if (goToHome)
                this.$router.push({name: "home"}).catch(error=>{});
        }
        else
             this.$router.push({name: "home"}).catch(error=>{});
    },
    
    methods: {
        openModalOrganigramme() {
            firebase_api.api.getDb().collection("club").doc(this.club.id).collection("joueurs").get().then(docs=>{
                var joueurs = [];
                this.organisateurs = [];
                docs.forEach(doc=>{
                    joueurs.push(doc.data());
                })
                for (var idUser in this.club.users) {
                    var user = this.club.users[idUser];
                    var joueur = joueurs.find(elt=>elt.userId === user.id) 
                    if (user.role == 'owner') {
                       if (typeof(joueur)!="undefined") {
                            this.gestionnaire = joueur;
                       }
                        else {
                            this.gestionnaire = JSON.parse(JSON.stringify(this.club.users[idUser]));
                            this.gestionnaire.nom = this.club.users[idUser].pseudo;
                        }
                    }
                    else if (user.role == 'admin') {
                        var joueur = joueurs.find(elt=>elt.userId ===  user.id) 
                        if (typeof(joueur)!="undefined")
                            this.organisateurs.push(joueur)
                    }
                }
                this.modalOrganigramme = true;
                
            })
        },
        closeEdit(createClub) {
            
            this.editClubModal=false
            
        },
        dayExpired()
            {
            var d1 = this.club.create;
            var today = new Date();
            var d2 = new Date(today.getFullYear(), today.getMonth(), today.getDate())
            var dated1 = new Date(d1);
            dated1 = new Date(dated1.getFullYear(), dated1.getMonth(), dated1.getDate())
            d1 = dated1.getTime();
            d1 = d1 / 86400000;
            d2 = d2.getTime() / 86400000;
            var diff = d1 - d2;
            diff += 5;
            return diff.toFixed(0);
        },
        
        closeLogin() {
            this.modalLogin=false;
            location.reload();
        },
        goDemandeAdhesion() {
            if (this.demandeNbAdhesion!=0)
                this.$router.push({name: "demandes", params: {id: this.club.id}}).catch(error=>{});
        },
        openModalDemandeAdhesion() {
            this.modalDemandeAdhesion = true;
        },
        demandeMembre() {
            var userOwner;
            for (var indexUser in this.club.users) {
                if (this.club.users[indexUser].role == 'owner') {
                    userOwner = this.club.users[indexUser];
                }
            }
            if (typeof(userOwner)!="undefined") {
            
                club_fct.object.demandeMembre(this.club, userOwner, this.$store.getters.getUser, this.joueurAdhesion);
                this.modalDemandeAdhesion = false;
            }
        },
        async setOpenModalPublic() {
            
            this.openModalPublic = true;
        },
       
        
       
        setRefreshFile() {
           // this.$router.go(0);
          this.$firestoreRefs.club.update({
               logo: true
           }).then(()=>{
              this.$router.go(0);
           })
        },
       
        deleteClub() {

        },
        goConcours() {
            
            this.$router.push({name: "concours", params: {id: this.club.id}}).catch(error=>{});
        },
        goMesClubs() {
            this.$router.push({name: "club"}).catch(error=>{});
        },
        goSaison() {
            this.$router.push({name: "saison", params: {id: this.club.id}}).catch(error=>{});
        },
        goMembres: function() {
            this.$router.push({name: "membres", params: {id: this.club.id}}).catch(error=>{});
        },
        upload() {
            document.getElementById("Supload").click();
        },
        async subscribe() {
            
            if (!this.clubIsSubscription)
            this.openAbonnement = true;
            /*
            */
           else {
               this.uploadInProgress=true;
               var urlReturn =  window.location.origin + "/club/" + this.club.id;
               const functionRef = firebase
                    .app()
                    .functions('europe-west1')
                    .httpsCallable('ext-firestore-stripe-subscriptions-createPortalLink');
                    const { data } = await functionRef({ returnUrl: urlReturn});
                    window.location.assign(data.url);
           }
        },
    }
}
</script>